import { useMemo } from "react";
import { renderMarkdown } from "@/shared/lib/markdown";
import { cn } from "@/shared/lib/utils";

/** Tartalmi szövegek (Markdown) megjelenítése — a `body` mezők a DB-ben MD-ként élnek
 *  (rendszerterv 7.). A tipográfiát a `.md-content` osztály adja (theme.css).
 *  A HTML forrása a saját `renderMarkdown`-unk (`html: false`), nem a felhasználó szövege. */
export function Markdown({ children, className }: { children: string; className?: string }) {
  const html = useMemo(() => renderMarkdown(children), [children]);
  return (
    <div
      className={cn("md-content text-[15px] leading-[1.55] text-ink-soft", className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
